import { generateInitApiState } from '@exxonmobil/uit-uda-ui-components-lib';
import { BaselineWorkCenterDays } from 'models/baselines';
import { IncrementalWorkCenter } from 'models/Incrementals';
import { RequiredWorkCenter } from 'models/required';
import { WorkCenter } from 'models/workcenters';
import { UiCommands } from 'pages/Incrementals/Commands/UiCommands';
import { RevisionCode } from 'pages/Incrementals/Incrementals.types';
import { UiViewModelState } from 'pages/Incrementals/UiState';
import { UiQueries } from 'pages/Incrementals/Queries/UiQueries';

export const fetchingIncrementalMessage: string = 'Fetching incrementals ...';
export const updatingIncrementalMessage: string = 'Updating incrementals ...';
export const approvingBaselineMessage: string = 'Approving incrementals ...';

export type IncrementalProviderValueType = {
  // Model the UI layout:
  // This state is generated from the combination' of API state
  // and user actions such as entering some data on screen.
  // This model is specifically curated for the UI presentation such that the UI makes minimal decisions for rendering;
  uiState: UiViewModelState;

  // Actions UI can perform
  uiCommands: UiCommands;

  // Query something about the ui
  uiQueries: UiQueries;
};

export const defaultRevisionCodesState = generateInitApiState<RevisionCode[]>(
  []
);
export const defaultWorkCentersState = generateInitApiState<WorkCenter[]>([]);
export const defaultIncrementalsState = generateInitApiState<
  IncrementalWorkCenter[]
>([]);
export const defaultBaselinesState = generateInitApiState<
  BaselineWorkCenterDays[]
>([]);
export const defaultRequiredState = generateInitApiState<RequiredWorkCenter[]>(
  []
);

export const initStateDataValue: IncrementalProviderValueType = {
  uiState: {
    isScreenLoading: true,
    screenError: null,
    justificationReasons: [],
    companies: [],
    workCenters: [],
    revisionCodes: [], // For the revision code drop down
    workCenterFilter: null, // No filter by default
    currentRevisionCode: null, // Set by choosing revision code in drop down
    currentWeekId: null, // What week is currently displayed
    weeks: [], // All of the weeks for the revision code
    isUserApprover: false // So UI can be altered based on user being an approver
  },

  // to mainly perform actions against uiState
  // https://martinfowler.com/bliki/CQRS.html
  uiCommands: {} as UiCommands,

  // to query information about uiState
  // https://martinfowler.com/bliki/CQRS.html
  uiQueries: {} as UiQueries
};
